import { Config } from 'tailwindcss';
import backgroundColors from './semanticColors/backgroundColors';
import borderColors from './semanticColors/borderColors';
import iconColors from './semanticColors/iconColors';
import textColors from './semanticColors/textColors';

export const semanticColorsConfig: Config['theme'] = {
  // * Background Color concerns
  backgroundColor: backgroundColors,
  gradientColorStops: backgroundColors,

  // * Border Color concerns
  borderColor: borderColors,
  stroke: borderColors,
  outlineColor: borderColors,
  ringColor: borderColors,

  // * Text Color concerns
  textColor: textColors,
  fill: iconColors,
};
